import Vue from 'vue'
import Vuex from 'vuex'
import routeData from './modules/routeData.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //餐单页面，时间状态 0 今天 1 历史
    currentTitle: 0,
    routePath:0
  },
  mutations: {

    historyTime(state) {
      state.currentTitle = 1
    },
    todayTime(state) {
      state.currentTitle = 0
    },
    routePathDashboard(state) {
      state.routePath = 0
    },
    routePathMenuQuery(state) {
      state.routePath = 1
    }
  },
  actions: {},
  modules: {
    routeData
  }
})